import { BomDto } from "src/dtos/bom/BomDto";
import { ProductOrderDto } from "src/dtos/productOrder/ProductOrderDto";
import { ProductResultDto } from "src/dtos/productResult/ProductResultDto";
import { PrdInspectResultDto } from "src/dtos/prdInspectResult/prdInspectResultDto";
import { WmsStockLotDto } from "src/dtos/wmsLot/wmsStockLotDto";
import { formatDate, toLocalDateTime } from "src/utils/string/stringUtil";

export type KSK2110_R01WorkTimeProcessType = 'workStart' | 'workEnd' | 'workStartReset' | 'workEndReset';

export interface KSK2110_R01Dto {
	// 기존: productWorkHeaderDto
	productOrderHeaderDto: KSK2110_R01HeaderDto;
	productResultHeaderDto: KSK2110_R01ProductResultDto;
	wmsStockLotDtoList: KSK2110_R01LotDto[];
	bomDtoList: KSK2110_R01DetailDto[];
	prdInspectResultDtoList: PrdInspectResultDto[];
}

/** PRD3010_R01HeaderDto 계열 — 작업지시(ProductOrder) 기준 */
export interface KSK2110_R01HeaderDto extends ProductOrderDto {

	itemCost: number;
	itemAccount: string;
	itemAccountNm?: string;

	productResultNo: string;
	productDt: string | undefined;

	productEmp: string;
	productEmpNm: string;

	warehouseCd: string;
	warehouseNm: string;
	outWarehouseCd: string;
	badWarehouseCd: string;

	logicCenter: string;
	logicCenterNm: string;
	productQty: number;
	badQty: number;
	acceptQty: number;

	itemStatus: string;

	/** API(PRD형) 작업시작/종료 */
	workStartDt?: string;
	workEndDt?: string;

	/** 키오스크 UI용 — workStartDt/workEndDt 매핑 */
	fromTime?: string;
	toTime?: string;
	timeParam?: string;

	/** 설비 Count (표시용) */
	plcCount: number;
}

export const defaultKSK2110_R01HeaderDto: KSK2110_R01HeaderDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	productOrderNo: '',
	compCd: '',
	compNm: '',
	orderDt: formatDate(new Date()),
	orderType: '',
	workplaceCd: '',
	workplaceNm: '',
	jobTeam: '',
	workProcess: '',
	itemCd: '',
	itemNm: '',
	itemSpec: '',
	itemUnit: '',
	orderQty: 0,
	orderEmp: '',
	orderEmpNm: '',
	productPlanNo: '',
	resultQty: 0,
	basOrderType: '',
	basOrderNo: '',
	basOrderItemNo: '',
	closeTag: "N",
	remark: '',

	itemCost: 0,
	itemAccount: '',
	itemAccountNm: '',

	productResultNo: '',
	productDt: formatDate(new Date()),

	productEmp: '',
	productEmpNm: '',

	warehouseCd: '',
	warehouseNm: '',
	outWarehouseCd: '',
	badWarehouseCd: '',

	logicCenter: '',
	logicCenterNm: '',
	productQty: 0,
	badQty: 0,
	acceptQty: 0,

	itemStatus: '',

	workStartDt: undefined,
	workEndDt: undefined,
	fromTime: undefined,
	toTime: undefined,
	timeParam: toLocalDateTime(new Date()),

	plcCount: 0,

	inserted: false,
	isModified: false,
}

/** one/productResult 응답의 workStartDt·workEndDt → 키오스크 fromTime·toTime */
export const mapKioskWorkTimes = <T extends {
	workStartDt?: string;
	workEndDt?: string;
	fromTime?: string;
	toTime?: string;
}>(data: T): T => ({
	...data,
	fromTime: data.workStartDt ?? data.fromTime,
	toTime: data.workEndDt ?? data.toTime,
	workStartDt: data.workStartDt ?? data.fromTime,
	workEndDt: data.workEndDt ?? data.toTime,
});

export interface KSK2110_R01ProductResultDto extends ProductResultDto {
	outWarehouseCd: string;
	badWarehouseCd: string;
}

export const defaultKSK2110_R01ProductResultDto: KSK2110_R01ProductResultDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	productResultNo: '',
	compCd: '',
	compNm: '',
	productDt: formatDate(new Date()),
	orderType: '',
	workplaceCd: '',
	workplaceNm: '',
	jobTeam: '',
	itemCd: '',
	itemStatus: '',
	itemNm: '',
	itemSpec: '',
	itemUnit: '',
	productOrderNo: '',
	orderQty: 0,
	productEmp: '',
	productEmpNm: '',
	workStartDt: toLocalDateTime(new Date()),
	workEndDt: undefined,
	productQty: 0,
	badQty: 0,
	acceptQty: 0,
	logicCenter: '',
	warehouseCd: '',
	warehouseNm: '',
	basOrderType: '',
	basOrderNo: '',
	basOrderItemNo: '',
	kpiYn: 'Y',
	inspectQty: 0,
	inspectYn: 'N',
	remark: '',

	outWarehouseCd: '',
	badWarehouseCd: '',

	inserted: false,
	isModified: false,
}


export interface KSK2110_R01LotDto extends WmsStockLotDto {

}

export const defaultKSK2110_R01LotDto: KSK2110_R01LotDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	warehouseCd: '',
	warehouseNm: '',
	lotNo: '',
	purchaseLotNo: '',
	lotCreateDt: '',
	itemCd: '',
	itemNm: '',
	itemSpec: '',
	itemUnit: '',
	itemStatus: '',
	lotQty: 0,
	transportNo: '',
	itemNo: '',
	remark: '',

	inserted: false,
	isModified: false,
}

export interface KSK2110_R01LotSearchDto extends WmsStockLotDto {

	lotNoInput: string;
	modelNo: string;
	bomUsingQty: number;
	transportQty: number;

}

export const defaultKSK2110_R01LotSearchDto: KSK2110_R01LotSearchDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	warehouseCd: '',
	warehouseNm: '',
	lotNo: '',
	purchaseLotNo: '',
	lotCreateDt: '',
	itemCd: '',
	itemNm: '',
	itemSpec: '',
	itemUnit: '',
	itemStatus: '',
	lotQty: 0,
	transportNo: '',
	itemNo: '',
	remark: '',

	lotNoInput: '',
	modelNo: '',
	bomUsingQty: 0,
	transportQty: 0,

	inserted: false,
	isModified: false,
}

export interface KSK2110_R01DetailDto extends BomDto {

	warehouseCd: string;
	warehouseNm: string;
	logicCenter: string;
	lotNo: string;
	itemStatus: string;
	itemNm: string;
	itemUnit: string;
	transportNo: string;
	itemNo: string;
	lotQty: number;
	bomUsingQty: number;
	transportQty: number;

}

export const defaultKSK2110_R01DetailDto: KSK2110_R01DetailDto = {

	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	prntItemcd: '',
	prntItemnm: '',
	childItemcd: '',
	childItemnm: '',
	itemSpec: '',
	bomSeq: 0,
	bomUseyn: '',
	bomUpdateNo: '',
	prntItemQty: 0,
	prntItemUnit: '',
	childItemUsage: 0,
	childItemUnit: '',
	fixLossqty: 0,
	materialIntype: 'PURCHASE',
	lossPercent: 0,
	remark: '',

	warehouseCd: '',
	warehouseNm: '',
	logicCenter: '',
	lotNo: '',
	itemStatus: '',
	itemNm: '',
	itemUnit: '',
	transportNo: '',
	itemNo: '',
	lotQty: 0,
	bomUsingQty: 0,
	transportQty: 0,

	inserted: false,
	isModified: false,
}


export interface KSK2110_R01InspectDto extends PrdInspectResultDto {

}

export const defaultKSK2110_R01InspectDto: KSK2110_R01InspectDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	inspectNo: '',
	inspectDt: formatDate(new Date()),
	compCd: '',
	inspectType: '',
	inspectorEmp: '',
	supplierCustom: '',
	workplaceCd: '',
	jobTeam: '',
	itemCd: '',
	workerEmp: '',
	inspectQty: 0,
	badQty: 0,
	acceptQty: 0,
	badCase: '',
	basOrderNo: '',
	basOrderItemno: '',
	basLotNo: '',
	remark: '',

	inserted: false,
	isModified: false,
}
